import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { LEAD_CAPTURE } from '@/composables/useLeadCaptureTabs'
import { useRevealed } from '@/helpers/revelio'
import { matchesRouteBase } from '@/services/platformRouting'

const STOREFRONT = '/storefront'

// leadCaptureGuard turns away an arrival; this turns you out of a page you are
// already standing on, because the word can be unsaid from anywhere in the app.
// It belongs to the pages that have to leave rather than to the nav that listed
// them, which is how it survived the move out of the storefront sidebar.
export function useLeadCaptureReveal() {
  const route = useRoute()
  const router = useRouter()

  watch(useRevealed(), isRevealed => {
    if (!isRevealed && matchesRouteBase(route.path, LEAD_CAPTURE)) router.replace(STOREFRONT)
  })
}
